import { Fragment } from 'react';
import { Link } from 'react-router-dom';
import Input from '../input/Input';
import inputTypes from './inputTypes';
import styles from './login.module.css';

const Login = ({ pageName }) => {
    const filteredInputTypes = inputTypes.filter((ele) => ele.page === pageName);
    let loginTitle;

    if (pageName === 'login') {
        loginTitle = "Login to your account";
    }
    if (pageName === 'register') {
        loginTitle = "Create a new account";
    }
    if (pageName === 'forget') {
        loginTitle = "Forget Password ?";
    }
    
    return (
        <section className={styles.login}>
            <div className={styles.loginContainer}>
                <div className={styles.loginImage}>
                    <Link to="/">
                        <img
                            className={styles.loginLogo}
                            src={process.env.PUBLIC_URL + `/assets/imgs/Logo.svg`}
                            alt="LogoImage"
                        />
                    </Link>
                    <h4 className={styles.loginTitle}>{loginTitle}</h4>
                    {pageName === "forget" &&
                        <p className={styles.forgetTxt}>Enter Your E-Mail or Phone number associated <br />
                            to your account to reset password
                        </p>
                    }
                </div>
                <form className={styles.loginForm}>
                    {filteredInputTypes.map((obj, index) => {
                        return (
                            <Input
                                key={obj.id}
                                inputType={obj.inputType}
                                placeholder={obj.placeholder}
                                id={obj.inputId}
                                ifRequired={obj.ifRequired}
                                labelTitle={obj.labelTitle}
                            />
                        )
                    })}

                    {pageName === "login" &&
                        <Fragment>
                            <button className={styles.loginBtn} type='submit'>Login</button>
                            <a href='/' className={styles.loginFaceBtn}>
                                <img className={styles.loginFaceBtnLogo} src={process.env.PUBLIC_URL + `/assets/imgs/facebook.svg`} alt="facebook" />
                                <span className={styles.loginFaceBtnTxt}>Login with facebook</span>
                            </a>
                            <div className={styles.loginLinks}>
                                <Link className={styles.loginForgetLink} to="/password/forget">Forget Password ?</Link>
                                <div  className={styles.loginLink}>
                                    <span>Do not have an account ?</span>
                                    <Link to="/register">Register</Link>
                                </div>
                            </div>
                        </Fragment>
                    }

                    {pageName === "register" &&
                        <Fragment>
                            <button className={styles.loginBtn} type='submit'>Register</button>
                            <div className={styles.loginLinks}>
                                <div className={styles.loginLink}>
                                    <span>By register, you agree to our</span>
                                    <a className={styles.loginTermsLink} href="/">Terms & Conditions</a>
                                </div>
                                <div  className={styles.loginLink}>
                                    <span>Already have an account ?</span>
                                    <Link to="/login">Login</Link>
                                </div>
                            </div>
                        </Fragment>
                    }
                    
                    {pageName === "forget" &&
                        <button className={styles.loginBtn} type='submit'>Reset Password</button>
                    }
                </form>
            </div>
        </section>
    )
}

export default Login;
